import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  Avatar
} from '@mui/material';
import {
  Inventory as StorageIcon,
  ChevronRight as ChevronRightIcon
} from '@mui/icons-material';

const QuickScanWidget = ({ onClick }) => {
  return (
    <Card 
      elevation={3}
      onClick={onClick}
      sx={{ 
        cursor: 'pointer',
        aspectRatio: '1',
        transition: 'all 0.3s',
        '&:hover': {
          elevation: 6,
          transform: 'translateY(-4px)',
        },
        background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
        color: 'white'
      }}
    >
      <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
          <Typography variant="body2" fontWeight="bold" color="white" sx={{ fontSize: '0.85rem' }}>
            Produksjonslager
          </Typography>
          <IconButton size="small" sx={{ color: 'white', p: 0 }}>
            <ChevronRightIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={{ textAlign: 'center', py: 0.5, flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Avatar
            sx={{
              width: 50,
              height: 50,
              margin: '0 auto 8px',
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              border: '2px solid rgba(255, 255, 255, 0.3)'
            }}
          >
            <StorageIcon sx={{ fontSize: 30, color: 'white' }} />
          </Avatar>
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.95)', fontWeight: 500, fontSize: '0.8rem' }}>
            Sett på / Ta ut
          </Typography>
          <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.8)', mt: 0.5, display: 'block', fontSize: '0.7rem' }}>
            Lagre eller hent deler
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default QuickScanWidget;
